export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    visible: !that.disabled,
  },
  {
    width: 40,
    align: 'center',
    slots: { default: 'drag' },
    titleHelp: { message: that.$l('table_header_help_drag') },
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 120,
    slots: { default: 'opt' },
  },

  {
    title: that.$l('table_label_process_name') || '工序名称',
    field: 'processName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_avg_test_time') || '测时平均',
    field: 'avgTestTime',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { avgTestTime: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_rating_factor') || '评比系数',
    field: 'ratingFactor',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { ratingFactor: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_working_hours') || '测定工时',
    field: 'workingHours',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { workingHours: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_relaxation_rate') || '宽放率',
    field: 'relaxationRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { relaxationRate: value } = row || {}
      return `${(value || 0).toLocaleString()}%`
    },
  },
  {
    title: that.$l('table_label_std_time') || '工序标工',
    field: 'stdTime',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { stdTime: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_workers_number') || '作业人数',
    field: 'workersNumber',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { workersNumber: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: 'UPH',
    field: 'uph',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { uph: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_uph10') || '核定产量',
    field: 'uph10',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { uph10: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_output_unit') || '产量单位',
    field: 'outputUnit',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_labor_rate') || '工费率',
    field: 'laborRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { laborRate: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_wages') || '工价(元)',
    field: 'wages',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { wages: value } = row || {}
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_remarks') || '备注',
    field: 'remarks',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
